import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchVehicleAccountsSuccess,
  fetchVehicleAccountsFailure,
  createPaymentSuccess,
  createPaymentFailure,
  createPaidPaymentSuccess,
  createPaidPaymentFailure,
} from "../slices/VehicleAccountSlice";
import { StatusCodes } from "http-status-codes";
import { request } from "src/utils/api";
import { CREATE_PAID_PAYMENT, CREATE_PAYMENT_HISTORY, FETCH_TABLE_DATA } from "../actions/vehicalaccountAction";
import notification from "antd/es/notification";

export function* fetchVehicleAccountsSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchVehicleAccountsSuccess(result.data));
    else { 
      yield put(fetchVehicleAccountsFailure(result.message));
       notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error:any) {
    yield put(fetchVehicleAccountsFailure(error.message));
  }
}


export function* createPaymentSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(createPaymentSuccess(result.data));
      notification.success({
        message: "Add ToPay success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(createPaymentFailure(result.message));
       notification.error({
        message: "Add ToPay Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(createPaymentFailure(error?.response?.data?.message || error.message || "Something went wrong!"));
  }
}

export function* createPaidSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);

    if (result.status === StatusCodes.OK) {
      yield put(createPaidPaymentSuccess(result.data));
      notification.success({
        message: "Payment success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(createPaidPaymentFailure(result.message));
       notification.error({
        message: "Payment Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(createPaidPaymentFailure(error?.response?.data?.message || error.message || "Something went wrong!"));
  }
}

export default function* vehicleAccountSaga() {
  yield all([
    takeLatest(FETCH_TABLE_DATA, fetchVehicleAccountsSaga),
    takeLatest(CREATE_PAYMENT_HISTORY, createPaymentSaga),
    takeLatest(CREATE_PAID_PAYMENT, createPaidSaga),
  ])
}
